import React from 'react';
import { CallToAction } from '../../../commonTypes/links';
import Link from '../../Link';
import {
  CtaWrapper,
  FeatureHeadingStyleProps,
  Heading,
  StyledPrimaryCta,
  StyledRichText,
  StyledSecondaryCta,
  Subheading,
  TextContainer,
} from './styles';

export type FeatureContentsProps = {
  title?: string;
  subtitle?: string;
  body: string;
  cta?: CallToAction;
  secondaryCta?: CallToAction;
  customBulletIcon?: string;
  shouldUsePrimaryCta?: boolean;
} & FeatureHeadingStyleProps;

const FeatureContents: React.FC<FeatureContentsProps> = ({
  title,
  subtitle,
  body,
  cta,
  secondaryCta,
  customBulletIcon,
  addImageToHeadingSpacingOnMobile = true,
  shouldUsePrimaryCta = false,
}) => {
  return (
    <>
      <TextContainer tabIndex={0}>
        {title && (
          <Heading addImageToHeadingSpacingOnMobile={addImageToHeadingSpacingOnMobile}>
            {cta?.url ? (
              <Link href={cta.url} onClick={cta.onClick} removeVisitedStyle>
                {title}
              </Link>
            ) : (
              title
            )}
          </Heading>
        )}
        {subtitle && <Subheading>{subtitle}</Subheading>}
        <StyledRichText
          html={body}
          customBulletIcon={customBulletIcon}
          addImageToFirstChildSpacingOnMobile={addImageToHeadingSpacingOnMobile}
        />
      </TextContainer>
      {(cta || secondaryCta) && (
        <CtaWrapper>
          {cta &&
            (!shouldUsePrimaryCta && !secondaryCta ? (
              <StyledSecondaryCta cta={cta} />
            ) : (
              <StyledPrimaryCta cta={cta} />
            ))}
          {secondaryCta && <StyledSecondaryCta cta={secondaryCta} />}
        </CtaWrapper>
      )}
    </>
  );
};

export default FeatureContents;
